
import React from 'react';
import { useNavigate } from "react-router-dom";
import { Trash2, Text, CircleCheckBig } from "lucide-react"

const ChallengeCard = ({ challenge, onComplete, onDelete }) => {
  const navigate = useNavigate();
  const handleComplete = () => {
    onComplete(challenge.id);
  };

  const GotoDetail = (id) => {
    navigate(`/app/challenge/${id}`);
  }

  return (
    <div className="relative bg-white rounded-xl min-h-50 shadow-sm border p-4 mb-4">
      <button
        onClick={() => GotoDetail(challenge.id)}
        title='Detail'
        className="absolute top-2 right-8 text-red-500 hover:text-red-700"
      >
        <Text color='blue' width={18} className='mr-1' />
      </button>
      <button
        onClick={() => onDelete(challenge.id)}
        title='Remove'
        className="absolute top-2 right-2 text-red-500 hover:text-red-700"
      >
        <Trash2 color='red' width={18} className='mr-1' />
      </button>

      <div className="flex items-center gap-4 mb-4">
        <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center" onClick={() => {
          GotoDetail(challenge.id)
        }}>
          <span className="text-2xl">{challenge?.icon}</span>
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2 mt-3">
            <span className="text-sm text-gray-500" onClick={() => {
              GotoDetail(challenge.id)
            }}>{challenge.title}</span>
          </div>
          <p className="font-medium">{challenge.start} - {challenge.end} </p>
          <span className="bg-red-100 text-red-600 text-xs px-2 py-0.5 rounded">{challenge.totalDay} days</span>

        </div>
      </div>

      <div className="bg-orange-100 rounded-full h-3 mb-4">
        <div className="bg-gradient-to-r from-orange-200 to-orange-500 h-full rounded-full" style={{ width: challenge.percentCompleteDay + "%" }}></div>
      </div>
      <p className="text-center text-sm text-gray-500 mt-2 mb-2">{challenge.totalCompeletedDay} day(s) completed per {challenge.totalDay} day(s)</p>

      {challenge.isCompleted ? <><div className='w-full text-center pt-3'>
        <CircleCheckBig color='green' width={36} className='mr-2 inline-block' />
      </div></> : <button
        className="w-full bg-white hover:bg-gray-100 text-green-500 border border-green-500 rounded-lg py-3 font-medium transition duration-300 ease-in-out transform hover:scale-105 flex items-center justify-center"
        onClick={handleComplete}
      >
        <Text color='green' width={18} className='mr-2' />
        COMPLETE
      </button>}

    </div>
  );
};

export default ChallengeCard;

